/* =========================================================
   CATALOGUE L'ART DU PHYSIQUE — script.js
   ========================================================= */

const CHECKOUT_URL = "https://cataloguelartduphysique.myshopify.com/cart/63236368859466:1";
const PROMO_END_DATE = "2026-09-30T23:59:00+02:00";

(function () {
  "use strict";
  var imgs = document.querySelectorAll("#viewer .slide img");
  imgs.forEach(function (img) {
    img.setAttribute("loading", "eager");
    if (img.dataset.src) img.src = img.dataset.src;
  });
})();

(function () {
  "use strict";

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const checkoutReady =
    typeof CHECKOUT_URL === "string" &&
    /^https?:\/\//i.test(CHECKOUT_URL) &&
    !/REMPLACER/i.test(CHECKOUT_URL);

  const toast = $("#toast");
  let toastTimer = null;

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add("is-visible"));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.classList.remove("is-visible");
      setTimeout(() => { toast.hidden = true; }, 300);
    }, 4200);
  }

  $$("[data-checkout]").forEach((el) => {
    if (checkoutReady) {
      el.setAttribute("href", CHECKOUT_URL);
      el.setAttribute("rel", "noopener");
    } else {
      el.setAttribute("href", "#offre");
      el.addEventListener("click", (e) => {
        e.preventDefault();
        showToast("Lien de paiement non configuré : renseignez CHECKOUT_URL dans script.js avant la mise en ligne.");
        const offre = $("#offre");
        if (offre) offre.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      });
    }
  });

  const endTime = new Date(PROMO_END_DATE).getTime();
  const countdowns = $$("[data-countdown]");

  function pad(n) { return String(n).padStart(2, "0"); }

  function renderCountdown() {
    if (!countdowns.length) return true;
    if (isNaN(endTime)) {
      countdowns.forEach((cd) => { cd.hidden = true; });
      return true;
    }
    const diff = endTime - Date.now();

    if (diff <= 0) {
      countdowns.forEach((cd) => {
        const grid = $("[data-cd-grid]", cd);
        const label = $(".countdown__label", cd);
        const over = $("[data-cd-over]", cd);
        if (grid) grid.hidden = true;
        if (label) label.hidden = true;
        if (over) over.hidden = false;
      });
      return true;
    }

    const s = Math.floor(diff / 1000);
    const values = {
      d: Math.floor(s / 86400),
      h: Math.floor((s % 86400) / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60
    };
    countdowns.forEach((cd) => {
      Object.keys(values).forEach((k) => {
        const el = $('[data-cd="' + k + '"]', cd);
        if (el) el.textContent = k === "d" ? String(values.d) : pad(values[k]);
      });
    });
    return false;
  }

  if (countdowns.length) {
    const finished = renderCountdown();
    if (!finished) {
      const timer = setInterval(() => {
        if (renderCountdown()) clearInterval(timer);
      }, 1000);
    }
  }

  const nav = $("#nav");
  const burger = $("#navBurger");
  const navLinks = $("#navLinks");

  if (burger && navLinks) {
    const closeMenu = () => {
      navLinks.classList.remove("is-open");
      burger.setAttribute("aria-expanded", "false");
      burger.setAttribute("aria-label", "Ouvrir le menu");
    };
    burger.addEventListener("click", () => {
      const open = navLinks.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", String(open));
      burger.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu");
    });
    $$("a", navLinks).forEach((a) => a.addEventListener("click", closeMenu));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && navLinks.classList.contains("is-open")) {
        closeMenu();
        burger.focus();
      }
    });
  }

  const stickybuy = $("#stickybuy");
  const hero = $("#hero");

  if (stickybuy) stickybuy.hidden = false;

  function onScroll() {
    const y = window.scrollY || 0;
    if (nav) nav.classList.toggle("is-scrolled", y > 24);
    if (stickybuy && hero) {
      const passed = y > hero.offsetHeight;
      stickybuy.classList.toggle("is-visible", passed);
    }
  }
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { onScroll(); ticking = false; });
  }, { passive: true });
  onScroll();

  const revealables = $$(".reveal");
  if (reduceMotion || !("IntersectionObserver" in window)) {
    revealables.forEach((el) => el.classList.add("is-in"));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    revealables.forEach((el) => io.observe(el));
  }

  const viewer = $("#viewer");
  if (viewer) {
    const slides = $$(".slide", viewer);
    const dotsWrap = $(".viewer__dots");
    const prev = $(".viewer__nav--prev", viewer);
    const next = $(".viewer__nav--next", viewer);
    let current = 0;

    const labels = slides.map((s) => {
      const cap = $("figcaption b", s);
      return cap ? cap.textContent.trim() : "Aperçu";
    });

    const dots = labels.map((label, i) => {
      const b = document.createElement("button");
      b.type = "button";
      b.setAttribute("role", "tab");
      b.setAttribute("aria-label", label);
      b.setAttribute("aria-selected", i === 0 ? "true" : "false");
      b.addEventListener("click", () => go(i));
      if (dotsWrap) dotsWrap.appendChild(b);
      return b;
    });

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle("is-active", k === current));
      dots.forEach((d, k) => d.setAttribute("aria-selected", k === current ? "true" : "false"));
    }

    if (prev) prev.addEventListener("click", () => go(current - 1));
    if (next) next.addEventListener("click", () => go(current + 1));

    viewer.setAttribute("tabindex", "0");
    viewer.setAttribute("role", "group");
    viewer.setAttribute("aria-label", "Aperçus de pages du catalogue — utilisez les flèches gauche et droite");
    viewer.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") { e.preventDefault(); go(current - 1); }
      if (e.key === "ArrowRight") { e.preventDefault(); go(current + 1); }
    });

    let startX = null;
    viewer.addEventListener("touchstart", (e) => { startX = e.touches[0].clientX; }, { passive: true });
    viewer.addEventListener("touchend", (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) go(current + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });
  }

})();

(function () {
  "use strict";

  function applyGrid(grid) {
    grid.classList.remove("grid");

    function set() {
      var w = window.innerWidth;
      var cols = "minmax(0, 1fr)";
      if (w >= 960) {
        cols = "repeat(3, minmax(0, 1fr))";
      } else if (w >= 640) {
        cols = "repeat(2, minmax(0, 1fr))";
      }
      grid.style.setProperty("display", "grid", "important");
      grid.style.setProperty("grid-template-columns", cols, "important");
      grid.style.setProperty("gap", "18px", "important");
    }
    set();
    window.addEventListener("resize", set);
  }

  var tries = 0;
  var timer = setInterval(function () {
    var grid = document.querySelector("#contenu .modules.grid--3");
    tries++;
    if (grid) {
      clearInterval(timer);
      applyGrid(grid);
    } else if (tries > 40) {
      clearInterval(timer);
    }
  }, 250);
})();